import { createAsyncThunk } from '@reduxjs/toolkit';
import { $api_lang } from '../../config/api';
import { LocalStore } from '../../helpers/localStore';

const lexiconStore = new LocalStore(localStorage, { prefix: 'lexicon' });
const CACHE_31_DAYS = 31 * 24 * 60 * 60 * 1000; // 31 days
const CACHE_24_HOURS = 24 * 60 * 60 * 1000; // 24 hours

export const getTranslates = createAsyncThunk(
  'lexicon/get_lexic',
  async (lang = 'en', { rejectWithValue }) => {
    const lg = lang === 'es' ? 'sp' : lang;
    const cacheKey = `translates_${lg}`;
    const cached = await lexiconStore.fetch(cacheKey);
    if (cached != null) return cached;
    try {
      const response = await $api_lang.get(`/lexic?service=Platform&lang=${lg}`);
      await lexiconStore.store(cacheKey, response.data, CACHE_24_HOURS);
      return response.data;
    } catch (e) {
      return rejectWithValue(`${e.response?.data?.message ?? e.message}`);
    }
  },
);

export const getLanguages = createAsyncThunk(
  'lexicon/get_language',
  async (_, { rejectWithValue }) => {
    const cacheKey = 'languages';
    const cached = await lexiconStore.fetch(cacheKey);
    if (cached != null) return cached;
    try {
      const response = await $api_lang.get('/language/');
      await lexiconStore.store(cacheKey, response.data, CACHE_31_DAYS);
      return response.data;
    } catch (e) {
      return rejectWithValue(`${e.response?.data?.message ?? e.message}`);
    }
  },
);
